var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { staticClass: "pa-2", attrs: { fluid: "" } },
    [
      _c("RangePicker", {
        attrs: { range: this.getDefaultWeek() },
        on: { reloadData: _vm.loadData }
      }),
      _vm._v(" "),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6", lg: "6" } },
            [
              _c("v-subheader", [_vm._v("Jumps")]),
              _vm._v(" "),
              _c(
                "v-data-table",
                {
                  attrs: {
                    headers: _vm.headers,
                    items: _vm.totals,
                    "items-per-page": 10
                  }
                },
                [
                  _c("template", { slot: "body.append" }, [
                    _c("tr", { staticClass: "pink--text" }, [
                      _c("th", { staticClass: "title" }, [_vm._v("Totals")]),
                      _vm._v(" "),
                      _c("th", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.sum(_vm.totals, "jumps")))
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.sum(_vm.totals, "wc")))
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.sum(_vm.totals, "wc2")))
                      ])
                    ])
                  ])
                ],
                2
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-col",
            { attrs: { cols: "12", md: "6", lg: "6" } },
            [
              _c("v-subheader", [_vm._v("Loads")]),
              _vm._v(" "),
              _c(
                "v-data-table",
                {
                  attrs: {
                    headers: _vm.loadsHeaders,
                    items: _vm.flightsTotals,
                    "items-per-page": 10
                  }
                },
                [
                  _c("template", { slot: "body.append" }, [
                    _c("tr", { staticClass: "pink--text" }, [
                      _c("th", { staticClass: "title" }, [_vm._v("Totals")]),
                      _vm._v(" "),
                      _c("th", { staticClass: "title" }, [
                        _vm._v(_vm._s(_vm.sum(_vm.flightsTotals, "total")))
                      ])
                    ])
                  ])
                ],
                2
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("v-subheader", [_vm._v("Packing Jobs")]),
      _vm._v(" "),
      _c(
        "v-data-table",
        {
          attrs: {
            headers: _vm.packingJobsHeaders,
            items: _vm.totalsbypacker,
            "items-per-page": 10
          }
        },
        [
          _c("template", { slot: "body.append" }, [
            _c(
              "tr",
              { staticClass: "pink--text" },
              _vm._l(_vm.packingJobsHeaders, function(item, index) {
                return _c("th", { staticClass: "title" }, [
                  _vm._v(
                    "\n" +
                      _vm._s(
                        index > 0
                          ? _vm.sum(_vm.totalsbypacker, item.value)
                          : " "
                      ) +
                      "\n                          "
                  )
                ])
              }),
              0
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }